module.exports = '<svg width="51" height="32" viewBox="0 0 51 32"><path d="M48 9.6h-3.2V3.2c0-1.77-1.43-3.2-3.2-3.2H3.2A3.2 3.2 0 0 0 0 3.2v25.6A3.2 3.2 0 0 0 3.2 32h38.4c1.77 0 3.2-1.43 3.2-3.2v-6.4H48c1.77 0 3.2-1.43 3.2-3.2v-6.4c0-1.77-1.43-3.2-3.2-3.2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/battery-empty-1.js
// module id = 1001
// module chunks = 14